import '../scss/_utility.scss';

const LoadUtilityClassesLast = () => {
  return <></>;
};

export default LoadUtilityClassesLast;
